<template>
  <div>
    <vx-card title="Contact Information" class="mb-base">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow"></div>
        <feather-icon icon="EditIcon" />
      </div>
      <table>
        <tr>
          <td class="font-semibold">Commercial Registration Type</td>
          <td>{{ data.commercialTypeName }}</td>
          <td class="font-semibold">Commercial Registration Prefix</td>
          <td>{{ data.commercialPrefixName }}</td>
        </tr>
        <tr>
          <td class="font-semibold">Company Name EN</td>
          <td colspan="3">{{ data.companyNameEn }}</td>
        </tr>
        <tr>
          <td class="font-semibold">Company Name TH</td>
          <td colspan="3">{{ data.companyNameTh }}</td>
        </tr>
        <tr>
          <td class="font-semibold">Tax ID</td>
          <td>{{ data.taxId }}</td>
          <td class="font-semibold">Branch ID</td>
          <td>{{ data.branchId }}</td>
        </tr>
        <tr>
          <td class="font-semibold">Country</td>
          <td>{{ data.countryName }}</td>
          <td class="font-semibold">Province</td>
          <td>{{ data.provinceName }}</td>
        </tr>
        <tr>
          <td class="font-semibold">Number of Employees</td>
          <td>{{ data.numberofEmployees }}</td>
        </tr>
        <tr>
          <td class="font-semibold">Address</td>
          <td colspan="3">
            {{ data.companyAddress }}
          </td>
        </tr>
        <tr>
          <td class="font-semibold">Company Establish</td>
          <td>{{ data.companyEstablishDate }}</td>
          <td class="font-semibold">Company Turnover</td>
          <td>{{ data.companyTurnOver }}</td>
        </tr>
        <tr>
          <td class="font-semibold">Company Company Website</td>
          <td>{{ data.companyWebSite }}</td>
          <td class="font-semibold">Telephone</td>
          <td>{{ data.companyTelephone }}</td>
        </tr>
      </table>
    </vx-card>
  </div>
</template>

<script>
import { _vendorservice } from "../../services/vendorservices";
export default {
  props: {
    propVendorID: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      data: {},
    };
  },
  created() {
    this.getGeneralInfo();
  },
  methods: {
    async getGeneralInfo() {
      this.data = await _vendorservice.GetVendorInfoById(this.propVendorID);
      // console.log(this.data);
    },
  },
};
</script>

<style lang="scss">
table {
  td {
    vertical-align: top;
    min-width: 300px;
    padding-bottom: 0.8rem;
    word-break: break-all;
  }

  &:not(.permissions-table) {
    td {
      @media screen and (max-width: 370px) {
        display: block;
      }
    }
  }
}
</style>
